import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const f5BigIp = defineConnector({
  identifier: "f5BigIp",
  name: "F5 BIG-IP",
  tagLine: "Application delivery and security appliance",
  logo,
  protocol: "http",
  tags: ["security", "it"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(`${instanceUrl || "https://bigip.example.com"}/mgmt`),
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Use your BIG-IP management credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Use the management URL, username, and password for your BIG-IP appliance.",
        },
      ],
    },
    {
      title: "Enter your BIG-IP details",
      items: [
        {
          kind: "baseUrl",
          label: "BIG-IP URL",
          placeholder: "https://bigip.example.com",
          required: true,
          helperText: "Enter the BIG-IP management URL.",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          helperText: "Use a user with access to the iControl REST API.",
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://bigip.example.com"}/mgmt/tm/sys/httpd`,
  },
});
